import { Outlet } from "react-router-dom";

const PublicChargeStation = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PublicChargeStation;